import * as React from 'react';
import { Badge, NavItem } from 'react-bootstrap';
import useCoachCounts, { ICoachCounts } from '@nkr/store/microsites/hooks/use-coach-counts';
import { NavWrapper } from './styles';

interface IProps {
    contactId: number;
    refreshKey?: number;
    counts?: ICoachCounts;
    search?: string;
}

export const COACH_SEARCH_QUERY_KEY = 'search';

export const readCoachSearchFromUrl = (): string =>
    new URLSearchParams(window.location.search).get(COACH_SEARCH_QUERY_KEY) ?? '';

const allTabs = [
    { label: 'Action Center', path: '/microsite/coach', countKey: null },
    { label: 'New Assignments', path: '/microsite/coach/new-assignments', countKey: 'newAssignments' },
    { label: 'Declined CS', path: '/microsite/coach/declined-cs', countKey: 'declinedCs' },
    { label: 'Pending Approval', path: '/microsite/coach/approval', countKey: 'pendingApproval' },
    { label: 'Pending Follow Up', path: '/microsite/coach/to-do', countKey: 'pendingFollowUp' },
    { label: 'Opted-Out', path: '/microsite/coach/opted-out', countKey: 'optedOut' },
    { label: 'All', path: '/microsite/coach/all', countKey: 'all' },
];

const CoachTabs: React.FC<IProps> = ({ contactId, refreshKey, counts: countsProp, search }) => {
    const pathname = window.location.pathname;
    const { counts: hookCounts } = useCoachCounts(countsProp ? null : contactId, refreshKey);
    const counts = countsProp ?? hookCounts;
    const activeTab = allTabs.find(t => pathname === t.path);
    const query = search ? `?${COACH_SEARCH_QUERY_KEY}=${encodeURIComponent(search)}` : '';

    return (
        <NavWrapper bsStyle='tabs' verticalAlign='center' minTabWidth={120} activeKey={activeTab ? activeTab.path : null}>
            {allTabs.map(t => (
                <NavItem key={t.path} eventKey={t.path} href={`${t.path}${query}`}>
                    {t.label}
                    {t.countKey && <>&nbsp;<Badge bsClass='badge pending'>{counts[t.countKey]}</Badge></>}
                </NavItem>
            ))}
        </NavWrapper>
    );
};

export default CoachTabs;
